{
	"closed_title": "Closed anomalies",
	"columns": {
		"applications": "Applications sent",
		"closed": "Closed on",
		"kind": "Kind",
		"not_delivered": "Applications not delivered",
		"note": "Note",
		"open_anomalies": "Open anomalies",
		"opened": "Opened on",
		"protocol": "Prot.",
		"reason": "Reason",
		"residence": "Residence"
	},
	"commands": {
		"close": "Close",
		"close_description": "The note stays with the anomaly and in the log. The application does not change.",
		"close_done": "Anomaly closed.",
		"close_submit": "Close with the note",
		"close_title": "Close the anomaly",
		"note": "Note",
		"note_required": "Write why you close it.",
		"notify": "Tell the manager",
		"notify_done_one": "Email sent to {{count}} manager.",
		"notify_done_other": "Email sent to {{count}} managers."
	},
	"detail": {
		"basis": {
			"pec_arrival": "Arrival at the PEC of the residence",
			"submitted": "Time the application was sent"
		},
		"closed_note": "Anomaly closed: no command available.",
		"fields": {
			"closed": "Closed on",
			"effective": "What counts for the deadline",
			"effective_basis": "Why",
			"kind": "Kind",
			"never": "Never",
			"note": "Closing note",
			"notified": "Manager told on",
			"opened": "Opened on",
			"protocol": "Protocol",
			"reason": "Technical reason",
			"recipient": "Refused address",
			"residence": "Residence",
			"submitted_at": "Signed on"
		},
		"not_found": "Anomaly not found",
		"sections": {
			"anomaly": "Anomaly",
			"application": "Application",
			"commands": "Commands"
		},
		"title": "Anomaly"
	},
	"empty_closed": "No closed anomaly",
	"empty_open": "No open anomaly",
	"filters": {
		"kind": "Kind",
		"state": "State"
	},
	"kind": {
		"email_bounced": "Bounced email",
		"offer_bounced": "Offer not delivered",
		"offer_not_sent": "Offer not sent",
		"ranking_failed": "Calculation failed",
		"transmission_not_delivered": "Application not delivered"
	},
	"no_residence": "No residence",
	"open_title": "Open anomalies",
	"page_title": "Sendings",
	"residences_empty": "No residence",
	"residences_title": "Residences",
	"state": {
		"closed": "Closed",
		"open": "Open"
	},
	"without_residence": "No residence: {{count}} open anomalies (bounced emails)"
}
